import type { ComponentRohsBriefingStep } from '@/shared/briefing/buildComponentRohsBriefing'
import type { RohsComponentComplianceFileDetailView } from '@/shared/hooks/api/rohsComplianceFiles'
import { V2ComponentRohsComplianceSlotStep } from './V2ComponentRohsComplianceSlotStep'
import { V2ComponentRohsTestReportAuditPanel } from './V2ComponentRohsTestReportAuditPanel'

export function V2ComponentRohsTestReportStep({
  step,
  index,
  componentId,
  file,
  canWrite,
  auditInProgress,
  auditScope = 'catalog',
  productId,
}: {
  step: ComponentRohsBriefingStep
  index: number
  componentId: string
  file: RohsComponentComplianceFileDetailView
  canWrite: boolean
  auditInProgress: boolean
  auditScope?: 'catalog' | 'product'
  productId?: string
}) {
  const hasFile =
    file.slots.find((slot) => slot.slotKind === 'TEST_REPORT')?.fileName != null
  return (
    <div className='space-y-0'>
      <V2ComponentRohsComplianceSlotStep
        step={step}
        index={index}
        componentId={componentId}
        file={file}
        slotKind='TEST_REPORT'
        canWrite={canWrite}
      />
      {hasFile && (
        <div className='mb-4 pr-4 pl-10'>
          <V2ComponentRohsTestReportAuditPanel
            componentId={componentId}
            file={file}
            canWrite={canWrite}
            auditInProgress={auditInProgress}
            scope={auditScope}
            productId={productId}
          />
        </div>
      )}
    </div>
  )
}
